import * as types from './mutation-types'

const mutation = {
  [types.NOTIFICATIONS_GET_ALL](state, notifications) {
    state.notification_list = notifications
  },
  [types.SET_SELECTED_NOTIFICATION](state, newValue) {
    state.selected_notification = newValue
  },
  [types.SET_SELECTED_NOTIFICATION_ADMIN](state, newValue) {
    state.selected_notification_admin = newValue
  },
  [types.SET_ACKKNOWLEDGE](state, notification) {
  	state.notification_list.map((n) => {
  		if(n.id === notification.id){
  			n.acknowledge = true;
  		}
  	})
  },
  [types.SAVE_NOTIFICATION](state, notification) {
    console.log(notification)
    //create
    if (notification.id === 0)
    {
      let newid = state.todos[state.todos.length -1].id ++
      notification.id = newid;
      state.notification_list.push( notification)
    }
    else {
      //update
      state.notification_list = [
        ...state.notification_list.filter(element => element.id !== notification.id),
        notification
      ]
    }
  }
}

export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/notifications/mutations.js